import { render, staticRenderFns } from "./VacancyCandidatesSent.vue?vue&type=template&id=5f9af537&scoped=true"
import script from "./VacancyCandidatesSent.vue?vue&type=script&lang=js"
export * from "./VacancyCandidatesSent.vue?vue&type=script&lang=js"
import style0 from "./VacancyCandidatesSent.vue?vue&type=style&index=0&id=5f9af537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9af537",
  null
  
)

export default component.exports